module.exports = __webpack_public_path__ + "img/btn-swiper-play-on-control-02.eb1d4168.svg";